import type {
  CollectionActions,
  CollectionStateSlice,
  Reference,
} from '@freelancer/datastore/core';
import {
  addWebsocketDocuments,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import {
  transformSearchActiveLoad,
  transformWebsocketSearchActiveLoad,
} from './search-active-loads.transformers';
import type { SearchActiveLoadsCollection } from './search-active-loads.types';

export function searchActiveLoadsReducer(
  state: CollectionStateSlice<SearchActiveLoadsCollection> = {},
  action: CollectionActions<SearchActiveLoadsCollection>,
): CollectionStateSlice<SearchActiveLoadsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'searchActiveLoads') {
        const { result, ref, order } = action.payload;

        return mergeDocuments<SearchActiveLoadsCollection>(
          state,
          transformIntoDocuments(result.projects, transformSearchActiveLoad),
          order,
          ref,
          result.total_count || 0,
        );
      }
      return state;
    }

    case 'WS_MESSAGE': {
      if (action.payload.parent_type === 'notifications') {
        const ref: Reference<SearchActiveLoadsCollection> = {
          path: {
            collection: 'searchActiveLoads',
            authUid: action.payload.toUserId,
          },
        };

        switch (action.payload.type) {
          case 'projectSearchActive':
            return addWebsocketDocuments(
              state,
              [action.payload],
              transformWebsocketSearchActiveLoad,
              ref,
            );

          default:
            return state;
        }
      }

      return state;
    }

    default:
      return state;
  }
}
